import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { appContext, loadAction } from '../../util/decorators';
import linkTag2Initializer from '../../util/linkTag2Initializer';
import loadDataSources from '../../action/loadDataSources';
import loadSelectedTemplates from '../../action/loadSelectedTemplates';
import Loader from '../Loader.jsx';
import StandardNews from './StandardNews.jsx';
import DualNews from './DualNews.jsx';
//import TripleNewsBox from './TripleNewsBox.jsx';

import BigNewsFirstItem from './BigNewsFirstItem.jsx';
import AlternatingNews from './AlternatingNews.jsx';
import NewsFeedHeading from './NewsFeedHeading.jsx';
import ArticleList from './ArticleList.jsx';
import PageWithSidebars from '../Page/PageWithSidebars.jsx';
import translateRouteParams from '../../util/translateRouteParams.js';
import newsFeedConfig from '../../config/newsFeed.json';
import LeagueWidgetsRow from './LeagueWidgetsRow.jsx';
import competitionToStageMapping from '../../config/competitionToStageMapping.json';
import InfiniteScrollLoader from '../InfiniteScrollLoader';
import NewsFeedMeta from './NewsFeedMeta';
import FeedContainerText from './FeedContainerText.jsx';
//import FeedContainerBox from './FeedContainerBox.jsx';
import TabMenu from '../Navigation/TabMenu';
import VideoList from '../Video/VideoList';
import TripleNewsBox from './VMTripleNewsBox.jsx';


import PageHeading from '../PageHeading.jsx';

const VMrouteParams = {"sports":"fodbold","competitions":"fifa-vm"};
// the data source to lazy load new items from when infinity scrolling


// the data source to lazy load new items from when infinity scrolling
const INFINITE_SCROLL_DATA_SOURCE = 'autoArticles';
const ARTICLES_LOADED_ON_SCROLL = 60;
const ARTICLES_LOADED_ON_LOAD = 20;
const VIDEOS_PER_REQUEST = 100;

const getNewsFeedConfig = (routeParams, country) => {
  // Only return the config if the sport param is the only param
  if (_.size(routeParams) <= 1) return newsFeedConfig[country][routeParams.sports || 'emfodbold'];
};

const mapStateToProps = state => ({
  manualArticles: state.dataSources.manualArticles,
  autoArticles: state.dataSources.autoArticles,
  videos: state.dataSources.videosWithEvent,
  selectedTemplates: state.selectedTemplates,
  country: state.country,
  language: state.language,
  routeParams: state.routeParams,
  // Datasources is used in linkTag2Initializer to see if there are more ads..
  dataSources: state.dataSources,
});

const loadContent = args => {
  const mappedParams = translateRouteParams(args.routeParams, 'dk');
  const config = getNewsFeedConfig(args.routeParams, 'dk');
  //const mappedParams = translateRouteParams(args.routeParams, args.country);
  //const config = getNewsFeedConfig(args.routeParams, args.country);
  return loadDataSources({
    ...args,
    dataSourceConfigs: {
      manualArticles: {
        provider: 'viasport',
        config: {
          method: 'manual',
          manualList: config ? config.manualList : null,
        },
      },
      autoArticles: 'VMautoArticles',
      popularVideos: 'popularVideos',
      videosWithEvent: 'videosWithEvent',
    },
    limit: {
      manualArticles: 100,
      popularVideos: 0,
      autoArticles: ARTICLES_LOADED_ON_LOAD,
      videosWithEvent: VIDEOS_PER_REQUEST,
    },
    routeParams: mappedParams.include,
    excludeParams: mappedParams.exclude,
  });
};

@connect(mapStateToProps)
@loadAction(loadContent)
@loadAction(loadSelectedTemplates)
@linkTag2Initializer('frontpage')
@appContext
export default class NewsFeedPage extends React.PureComponent {

  static defaultProps = {
    activeSection: 'emfodbold',
  }

  constructor(props) {
    super(props);
    this.state = {
      activeSection: props.activeSection,
    };
    this.currentArticleOffset = _.size(props.dataSources.autoArticles) || ARTICLES_LOADED_ON_LOAD;
  }

  componentDidUpdate(previousProps) {
    if (previousProps.routeParams !== this.props.routeParams) {
      this.currentArticleOffset = ARTICLES_LOADED_ON_LOAD;
    }
  }

  loadMoreArticles() {
    const { manualArticles, routeParams, country, language, dispatch } = this.props;

    const excludedSlugs = manualArticles ? manualArticles.map(article => ({ slug: article.slug })) : [];
    const mappedParams = translateRouteParams(routeParams, country);

    const promise = dispatch(loadDataSources({
      dataSourceConfigs: {[INFINITE_SCROLL_DATA_SOURCE]: INFINITE_SCROLL_DATA_SOURCE},
      routeParams: mappedParams.include,
      excludeParams: _.concat(excludedSlugs, mappedParams.exclude || []),
      limit: {
        [INFINITE_SCROLL_DATA_SOURCE]: ARTICLES_LOADED_ON_SCROLL,
      },
      offset: {
        [INFINITE_SCROLL_DATA_SOURCE]: this.currentArticleOffset,
      },
      country,
      language,
    }));

    this.currentArticleOffset += ARTICLES_LOADED_ON_SCROLL;

    return promise;
  }

  loadMoreVideos = (routeParams, country, offset, language) => {
    return this.props.dispatch(loadDataSources({
      dataSourceConfigs: {
        videosWithEvent: 'videosWithEvent',
      },
      offset: {
        videosWithEvent: offset,
      },
      country: country,
      routeParams: routeParams,
      language: language,
    }));
  }

  render() {
    const { autoArticles, manualArticles, videos, selectedTemplates, country, language, routeParams } = this.props;
    const { activeSection } = this.state;

    const feedConfig = getNewsFeedConfig(routeParams, country);
    const templateKey = feedConfig && feedConfig.templateId;
    const templateConf = _.find(selectedTemplates, { page: templateKey }) || {};
    let selectedTemplate = _.last((templateConf.template || '').split('.'));
    
    let isFodboldPage = false;
  	if (routeParams.sports === 'fodbold') {
  		isFodboldPage = true;
  		//console.log(` routeParams render NEWFeedPage:  ` +  JSON.stringify(routeParams.sports));
  		//console.log(` routeParams render isFodboldPage:  ` +  isFodboldPage);
    }
    console.log(`Newsfeed isFodboldPage:  ` +  isFodboldPage);

    // Workaround for having videotab on startpage to avoid piping it through template flow
    if (activeSection === 'event-video' && _.size(routeParams) < 1) {
      selectedTemplate = 'event-video';
    }
	
    const allArticles = _.uniqBy(_.concat(manualArticles || [], autoArticles || []), 'id');
    let pageBody;
    let topView;
    if (!_.isEmpty(allArticles)) {
      
        //pageBody = <ArticleList additionalContent={leagueWidgets} articles={autoArticles} />;
        pageBody = <TripleNewsBox articles={allArticles} country={country} showCompetitionName />;

      // autoArticles and manualArticles is undefined during load.
    } else if (!autoArticles && !manualArticles) {
      pageBody = <Loader />;
    } else {
      pageBody = this.context.app.t('InfiniteScroll.no_more_articles');
    }

    return (
     
      <PageWithSidebars topView={topView} wrapInContainer={false}>
      	
        <NewsFeedMeta routeParams={routeParams} country={country} />

        <div className="row news-feed-heading-row">
        
            <div className="template-item col-xs-12">
            	<div className="emheader">
            		<PageHeading firstPart='FIFA' secondPart='VM 2023 (k)' />
                </div>
                 
            </div>
        </div>
        {pageBody}
        { selectedTemplate !== 'event-video' && <InfiniteScrollLoader lastRequestedOffset={this.currentArticleOffset}
                              loadedOffset={_.size(autoArticles)}
                              loadMore={() => this.loadMoreArticles()} /> }
      </PageWithSidebars>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/NewsFeed/VMNewsFeedPage.jsx